import { CreditCard, Landmark } from "lucide-react";

export function PaymentMethods() {
  return (
    <div data-testid="payment-methods" className="space-y-2">
      <p className="text-xs uppercase tracking-widest text-slate-400">Metodo di pagamento</p>
      <label data-testid="pay-method-bank" className="flex cursor-pointer items-center gap-3 rounded-xl border border-amber-500 bg-amber-500/10 p-3">
        <input type="radio" name="pay" defaultChecked className="accent-amber-500" />
        <Landmark className="h-4 w-4 text-amber-400" />
        <span className="text-sm text-white">Bonifico bancario istantaneo <span className="text-slate-400">· IBAN e causale dopo la conferma</span></span>
      </label>
      <label data-testid="pay-method-card" className="flex cursor-not-allowed items-center gap-3 rounded-xl border border-white/10 p-3 opacity-60">
        <input type="radio" name="pay" disabled />
        <CreditCard className="h-4 w-4 text-slate-400" />
        <span className="text-sm text-slate-300">Carta di credito (Stripe) <span className="text-xs text-slate-500">· disponibile a breve</span></span>
      </label>
    </div>
  );
}
